export function getWebResourceUrl(webResourceName, cdsBaseUrl) {
    var _a, _b, _c, _d;
    if (cdsBaseUrl === void 0) { cdsBaseUrl = ""; }
    // Note: globalContext.getWebResourceUrl() is preferred as the urls it returns can be cached for longer.
    // Note: using globalThis instead of window to avoid errors when running unit tests in nodejs.
    return (((_d = (_c = (_b = (_a = globalThis.Xrm) === null || _a === void 0 ? void 0 : _a.Utility) === null || _b === void 0 ? void 0 : _b.getGlobalContext) === null || _c === void 0 ? void 0 : _c.call(_b)) === null || _d === void 0 ? void 0 : _d.getWebResourceUrl(webResourceName)) || "".concat(cdsBaseUrl, "/WebResources/").concat(webResourceName));
}
